/**
 * Form helper functions. Pure functions for use in form hooks.
 * Use createHandleChange to get a consistent change handler that updates form data and clears alerts.
 */

/**
 * Returns a change handler that updates form data by name/value and clears form error/success.
 * @param {function} setFormData - React setState for form data
 * @param {function} setFormError - React setState for form error message
 * @param {function} setFormSuccess - React setState for form success message
 * @returns {function} (e: SyntheticInputEvent) => void
 */
export function createHandleChange(setFormData, setFormError, setFormSuccess) {
  return (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormError('');
    setFormSuccess('');
  };
}

/**
 * Clear form alert messages. Use at the start of submit or when switching mode.
 * @param {function} setFormError
 * @param {function} setFormSuccess
 */
export function clearFormAlerts(setFormError, setFormSuccess) {
  setFormError('');
  setFormSuccess('');
}
